import { render, staticRenderFns } from "./UploadingStatus.vue?vue&type=template&id=1c901023&scoped=true"
import script from "./UploadingStatus.vue?vue&type=script&lang=js"
export * from "./UploadingStatus.vue?vue&type=script&lang=js"
import style0 from "./UploadingStatus.vue?vue&type=style&index=0&id=1c901023&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c901023",
  null
  
)

export default component.exports